import { AuthBrandHeading } from '@/auth/auth-brand-heading';
import { Link } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';

/**
 * Password Changed Success — Phase 6 of PROD-893.
 *
 * Terminal page reached after Phase 3b (reset password new password),
 * Phase 4 (create password via email link), and Phase 5 → Phase 4 chain.
 *
 * Flutter source: `password_changed_success/presentation/pages/
 * password_changed_success_screen.dart`. Static — no state, no API,
 * no BLoC events that matter (the Flutter BLoC only handles a
 * LoginLoadingBeginState that isn't triggered from this screen — dead
 * artifact).
 *
 * Verbatim strings from Flutter intl:
 *   - yourPasswordIsSet → "Your password is set"
 *   - youCanNowLogInWithYourNewPassword → "You can now log in with your new password"
 *   - logIn → "Log in"
 */
export function PasswordChangedPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-surface-sidebar px-4">
      <div className="w-90 max-w-full rounded-lg border border-border-default bg-surface-card p-8 flex flex-col items-center gap-4 text-center">
        <CheckCircle2 className="h-20 w-20 text-status-success" />
        <AuthBrandHeading
          title="Your password is set"
          subtitle="You can now log in with your new password"
        />
        <Link
          to="/login"
          className="mt-4 inline-flex items-center justify-center rounded-md bg-brand-primary px-6 py-2.5 text-sm font-semibold text-white hover:bg-blue-600"
        >
          Log in
        </Link>
      </div>
    </div>
  );
}

export default PasswordChangedPage;
